// tog'a 1295 (2026-09-05): «Qarzdorlarga avtomatik SMS/Telegram eslatma (BELGILANGAN INTERVALDA)».
// Avval interval kodga qattiq yozilgan edi (har kuni 09:00). Endi shu yerda sozlanadi:
// yoqish, necha kunda bir, soat, «muddat yaqin» oynasi va kanallar. «Отправить сейчас» — sinov uchun darhol yuboradi.
import { useMutation, useQuery } from "@tanstack/react-query"
import { Button, Checkbox, InputNumber, Select, Space, Switch, Tag, Tooltip, message } from "antd"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { request } from "../../../../utils/config"

const GET = async () => (await request({ url: "Notifications/DebtReminderSettings" })).data
const SAVE = async (body: any) => (await request({ url: "Notifications/DebtReminderSettings", method: "PUT", data: body })).data
const RUN = async () => (await request({ url: "Notifications/DebtReminderRunNow", method: "POST" })).data

export default function DebtReminders() {
  const { t } = useTranslation()
  const { data, refetch, isLoading } = useQuery(["DEBT_REMINDER_SETTINGS"], GET, { staleTime: 30000 })
  const [f, setF] = useState<any>({ enabled: true, intervalDays: 1, hourLocal: 9, dueSoonDays: 3, notifyGroup: true, notifyClientTelegram: true, notifyClientSms: false, activityNotify: true, quietFromHour: 22, quietToHour: 8 })
  useEffect(() => { if (data) setF((p: any) => ({ ...p, ...data })) }, [data])
  const canEdit = !!data?.canEdit

  const { mutate: save, isLoading: saving } = useMutation(SAVE, {
    onSuccess: () => { message.success(t("drSaved")); refetch() },
    onError: (e: any) => message.error(e?.response?.data?.message || t("error")),
  })
  const { mutate: runNow, isLoading: running } = useMutation(RUN, {
    onSuccess: (r: any) => {
      const txt = `${t("drResult")}: ${r?.reason || "OK"} — ${t("drOverdue")}: ${r?.overdue ?? 0}, ${t("drDueSoon")}: ${r?.dueSoon ?? 0}, Telegram: ${r?.telegramSent ?? 0}, SMS: ${r?.smsSent ?? 0}${r?.groupSent ? ", " + t("drGroupSent") : ""}`
      r?.sent ? message.success(txt, 8) : message.info(txt, 8)
    },
    onError: (e: any) => message.error(e?.response?.data?.message || t("error")),
  })

  const set = (k: string, v: any) => setF((p: any) => ({ ...p, [k]: v }))
  const hours = Array.from({ length: 24 }, (_, i) => ({ value: i, label: `${String(i).padStart(2, "0")}:00` }))
  const chip = (ok: boolean, label: string) => (
    <Tooltip title={ok ? t("drConfigured") : t("drNotConfigured")}><Tag color={ok ? "green" : "default"} style={{ margin: 0 }}>{label}</Tag></Tooltip>
  )

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10, opacity: isLoading ? 0.6 : 1 }}>
      <Space wrap>
        <Switch checked={!!f.enabled} disabled={!canEdit} onChange={(v) => set("enabled", v)} />
        <span>{t("drEnabled")}</span>
      </Space>
      <Space wrap>
        <span>{t("drEvery")}</span>
        <InputNumber min={1} max={30} value={f.intervalDays} disabled={!canEdit} onChange={(v) => set("intervalDays", Number(v) || 1)} style={{ width: 80 }} />
        <span>{t("drDays")}</span>
        <span style={{ marginLeft: 8 }}>{t("drAtHour")}</span>
        <Select options={hours} value={f.hourLocal} disabled={!canEdit} onChange={(v) => set("hourLocal", v)} style={{ width: 100 }} />
      </Space>
      <Space wrap>
        <span>{t("drDueSoonWindow")}</span>
        <InputNumber min={0} max={60} value={f.dueSoonDays} disabled={!canEdit} onChange={(v) => set("dueSoonDays", Number(v) || 0)} style={{ width: 80 }} />
        <span>{t("drDays")}</span>
      </Space>
      <Space direction="vertical" size={4}>
        <Checkbox checked={!!f.notifyGroup} disabled={!canEdit} onChange={(e) => set("notifyGroup", e.target.checked)}>
          {Number(data?.tenantId || 1) > 1 ? t("drNotifyGroupPartner") : t("drNotifyGroup")} {chip(!!data?.groupConfigured, "Telegram")}
        </Checkbox>
        <Checkbox checked={!!f.notifyClientTelegram} disabled={!canEdit} onChange={(e) => set("notifyClientTelegram", e.target.checked)}>
          {t("drNotifyClientTg")} {chip(!!data?.clientBotConfigured, "@SavClientBot")}
        </Checkbox>
        <Checkbox checked={!!f.notifyClientSms} disabled={!canEdit} onChange={(e) => set("notifyClientSms", e.target.checked)}>
          {t("drNotifyClientSms")} {chip(!!data?.smsConfigured, "SMS")}
        </Checkbox>
      </Space>
      {/* tog'a #2064 (2026-09-15): har harakatda mijozga BITTA qarz xabari + jim soat (Boshliq Q8) */}
      <div style={{ borderTop: "1px dashed #d1d5db", paddingTop: 10, display: "flex", flexDirection: "column", gap: 8 }}>
        <Space wrap>
          <Switch checked={f.activityNotify !== false} disabled={!canEdit} onChange={(v) => set("activityNotify", v)} />
          <span>{t("drActivityNotify")}</span>
        </Space>
        <span style={{ color: "#6b7280", fontSize: 12 }}>{t("drActivityNotifyHint")}</span>
        <Space wrap>
          <span>{t("drQuietHours")}</span>
          {/* tor oynada ikki soat va chiziq birga qoladi (qatorga ajralib ketmasin) */}
          <Space size={6}>
            <Select options={hours} value={f.quietFromHour ?? 22} disabled={!canEdit} onChange={(v) => set("quietFromHour", v)} style={{ width: 100 }} />
            <span>—</span>
            <Select options={hours} value={f.quietToHour ?? 8} disabled={!canEdit} onChange={(v) => set("quietToHour", v)} style={{ width: 100 }} />
          </Space>
        </Space>
      </div>
      <Space wrap>
        <Button type="primary" loading={saving} disabled={!canEdit} onClick={() => save({
          enabled: !!f.enabled, intervalDays: Number(f.intervalDays) || 1, hourLocal: Number(f.hourLocal) || 0, dueSoonDays: Number(f.dueSoonDays) || 0,
          notifyGroup: !!f.notifyGroup, notifyClientTelegram: !!f.notifyClientTelegram, notifyClientSms: !!f.notifyClientSms,
          activityNotify: f.activityNotify !== false, quietFromHour: Number(f.quietFromHour ?? 22), quietToHour: Number(f.quietToHour ?? 8),
        })}>{t("save")}</Button>
        <Button loading={running} disabled={!canEdit} onClick={() => runNow()}>{t("drRunNow")}</Button>
        <span style={{ color: "#6b7280", fontSize: 12 }}>
          {t("drLastRun")}: {data?.lastRunDate ? new Date(data.lastRunDate).toLocaleString("ru") : "—"}
        </span>
      </Space>
    </div>
  )
}
